


/* LEAVE REQUEST */
 
export const GET_LEAVE_REQUESTS = "GET_LEAVE_REQUESTS"
export const GET_LEAVE_REQUESTS_SUCCESS = "GET_LEAVE_REQUESTS_SUCCESS"
export const GET_LEAVE_REQUESTS_FAIL = "GET_LEAVE_REQUESTS_FAIL"

export const GET_LEAVE_REQUEST_DETAIL = "GET_LEAVE_REQUEST_DETAIL"
export const GET_LEAVE_REQUEST_DETAIL_SUCCESS = "GET_LEAVE_REQUEST_DETAIL_SUCCESS"
export const GET_LEAVE_REQUEST_DETAIL_FAIL = "GET_LEAVE_REQUEST_DETAIL_FAIL"

export const ADD_LEAVE_REQUEST = "ADD_LEAVE_REQUEST"
export const ADD_LEAVE_REQUEST_SUCCESS = "ADD_LEAVE_REQUEST_SUCCESS"
export const ADD_LEAVE_REQUEST_FAIL = "ADD_LEAVE_REQUEST_FAIL"

export const UPDATE_LEAVE_REQUEST = "UPDATE_LEAVE_PLAN"
export const UPDATE_LEAVE_REQUEST_SUCCESS = "UPDATE_LEAVE_REQUEST_SUCCESS"
export const UPDATE_LEAVE_REQUEST_FAIL = "UPDATE_LEAVE_REQUEST_FAIL"

export const DELETE_LEAVE_REQUEST = "DELETE_LEAVE_REQUEST"
export const DELETE_LEAVE_REQUEST_SUCCESS = "DELETE_LEAVE_REQUEST_SUCCESS"
export const DELETE_LEAVE_REQUEST_FAIL = "DELETE_LEAVE_REQUEST_FAIL"